$('.form__row input, .form__row .form__textarea').focus(function(){
	$(this).removeClass('valid');
});
$('.form__row input, .form__row .form__textarea').blur(function(){
	if ($(this).val() != '' && $(this).val() != '+7 (___) ___-__-__')
		$(this).addClass('valid');
	else
		$(this).removeClass('valid');
});